import React from 'react'
import { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { useLoading } from '../../../context/LoadingContext';
import { CiEdit } from "react-icons/ci";

function Bom_master() {

  const { setLoading } = useLoading();
  const [showForm, setShowForm] = useState(false);

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };
  const [isEditMode, setIsEditMode] = useState(false);
  const [items, setItems] = useState([]);
  const [inventoryItems, setInventoryItems] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [bom, setBom] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

  const [formData, setFormData] = useState({
    product: '',
    qty: '',
    loss: '',
    tableRow: [{ item: "", qty: "" ,rate:'',stock:''}],
  })

  const handleAddClick = () => {
    setShowForm(true);
  }


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const addRow = () => {
    setFormData(prev => ({
      ...prev,
      tableRow: [...prev.tableRow, { item: "", qty: "" }]
    }));
  };

  const deleteRow = (index) => {
    setFormData(prev => ({
      ...prev,
      tableRow: prev.tableRow.filter((_, i) => i !== index)
    }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const payload = {
      product: formData.product,
      qty: formData.qty,
      loss: formData.loss,
    
      items: formData.tableRow.map(row => ({
        item: row.item,
        qty: row.qty ?? 0,
         rate: row.rate ,   
    stock: row.stock 
      })),
    };

    try {



      if (isEditMode && editingCompanyId) {
        const res = await axios.put(
          `https://api.skyguard.group/api/update-bom/${editingCompanyId}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        const res = await axios.post(
          "https://api.skyguard.group/api/add-bom",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      }


      fecthBomDetail();
      resetForm();
      showToast(
        isEditMode
          ? "BOM Updated Successfully!"
          : "BOM Added Successfully!",
        "success"
      );
      // fecthBatchDetail();

      setShowForm(false)
    } catch (err) {
      console.error(err);
      alert("Failed to save");
    }
  };



  const handleEdit = (form) => {
   
    const parsedProduct =
      form.product && typeof form.product === "string"
        ? JSON.parse(form.product)
        : form.product;

    const parsedItems =
      form.items && typeof form.items === "string"
        ? JSON.parse(form.items)
        : [];

    setFormData({
      product: parsedProduct,
      qty: form.qty ?? 0,
      loss: form.loss ?? 0,
      tableRow: parsedItems.map(row => ({
        item: row.item,
        qty: row.qty ?? '',
        rate:row.rate || '',
        stock:row.stock || '',
      })),
    });

    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);
  };


  const resetForm = () => {
    setFormData({
      product: "",
      qty: "",
      loss: "",
      tableRow: [{ item: "", qty: "" }],
    });
  };



  const fecthDetail = async () => {
    try {
      const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');
      const items = resInventory.data.result || [];

      const options = items.map(item => ({
        value: item.id,
        label: item.name,
          rate: item.rate,   
  stock: item.stock
      }));


      setInventoryItems(options);
      setProductOptions(options);
    } catch (error) {
      console.log(error)
    }
  };


  const fecthBomDetail = async () => {
    setLoading(true)
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-bom');

      setBom(res.data);
     

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    fecthDetail();
    fecthBomDetail();
  }, []);



const filterBOm = bom.filter((tt) => {
  const term = searchTerm.toLowerCase();

  if (!tt.product) return false;

  try {
    const parsedProduct =
      typeof tt.product === "string"
        ? JSON.parse(tt.product)
        : tt.product;

    return parsedProduct?.name?.toLowerCase().includes(term);
  } catch (err) {
    return false;
  }
});



  return (
    <div className='main-section'>
      <ToastNotification
        show={toast.show}
        message={toast.message}
        bg={toast.bg}
        onClose={() => setToast({ ...toast, show: false })}
      />

      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        <h3 className='my-3 fw-bold fs-5 golos'>Bill Of Material</h3>
        <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
          <div class="col-12 col-md-4">
            <input
              type="text"
              class="form-control"
              id="searchInput"
              placeholder="Search by Machine Name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="col-12 col-md-2 d-flex justify-content-end">
            <button className='btn btn-success' onClick={handleAddClick} >
              <AiOutlinePlusCircle size={20} /> Add
            </button>
          </div>
        </div>


        {showForm && (
          <form onSubmit={handleUpdate}>


            <div className='card p-3 my-3 shadow-sm bg-white border'>
              <div className='row'>

                <div className='col-12'>
                  <div className='row g-3'>

{isEditMode && (
  <div className="mb-3">
    <span className="badge bg-primary px-3 py-2">
      {formData.product?.name || "No Product"}
    </span>
  </div>
)}

                    <div className="col-12 col-sm-12  col-md-4">
                      <label className="form-label fw-medium">Product</label>

                      <Select
                        options={productOptions}
                        value={
                          productOptions.find(
                            opt => opt.value === formData.product?.id
                          ) || null
                        }
                        onChange={(option) =>
                          setFormData(prev => ({
                            ...prev,
                            product: option
                              ? { id: option.value, name: option.label }
                              : null
                          }))
                        }
                           menuPortalTarget={document.body}
                                styles={{
                                  container: base => ({ ...base, width: "100%" }),
                                  menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                        placeholder="Select product"
                      />


                    </div>

                    <div className="col-12 col-md-4">
                      <label className="form-label fw-medium">QTY </label>
                      <input
                        type="text"
                        className="form-control"
                        name="qty"
                        value={formData.qty}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-12 col-md-4">
                      <label className="form-label fw-medium">Production Loss </label>
                      <input
                        type="text"
                        className="form-control"
                        name="loss"
                        value={formData.loss}
                        onChange={handleChange}
                      />
                    </div>



                    <div className="table-responsive my-4">
                      <div className="d-flex justify-content-end mb-2 col-md-1">
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={addRow}
                        >
                          + Add Item
                        </button>
                      </div>
                      <table className="table table-bordered mx-auto text-center align-middle w-50 w-sm-100 ">
                        <thead className="table-primary">
                          <tr>
                            <th>Item</th>
                            <th>Qty</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData?.tableRow.map((item, idx) => (
                            <tr key={idx}>
                              <td>


                              

                                <Select
  options={inventoryItems}
  value={
    inventoryItems.find(opt => opt.value === item.item) || null
  }
  placeholder="Select Item"
  onChange={(selected) => {
    const updated = [...formData.tableRow];


    const selectedItem = inventoryItems.find(i => i.value === selected.value);

    updated[idx] = {
      ...updated[idx],
      item: selected.value,
      rate: selectedItem.rate, 
      stock: selectedItem.stock, 
    };

    setFormData(prev => ({ ...prev, tableRow: updated }));
  }}

     menuPortalTarget={document.body}
                                styles={{
                                  container: base => ({ ...base, width: "100%" }),
                                  menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
/>


                              </td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control form-control-sm "
                                  value={formData.tableRow[idx].qty }
                                  onChange={(e) => {
                                    const updated = [...formData.tableRow];
                                    updated[idx].qty = e.target.value;
                                    setFormData(prev => ({ ...prev, tableRow: updated }));
                                  }}
                                />
                              </td>
                              <td className="text-center">
                                <button type="button" className="btn btn-danger btn-sm"
                                  onClick={() => deleteRow(idx)}
                                >
                                  <AiOutlineDelete size={22} />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>




                <div className='col-12 d-flex justify-content-center gap-2 mt-4'>
                  <button type="submit" className='btn btn-success'>{isEditMode ? "Update" : "Save"}</button>
                  <button type='button' className='btn btn-danger' onClick={() => { setShowForm(false); setIsEditMode(false); resetForm(); }}>Cancel</button>
                </div>
              </div>
            </div>


          </form>
        )}


        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover text-center align-middle'>
            <thead className='table-info'>
              <tr>
                   <th scope='col' >SN </th>
                   
                <th scope='col' >Action</th>
                <th scope='col' >Machine Name </th>
                <th scope='col'>Qty</th>

                <th scope='col' >Production Loss </th>


              </tr>
            </thead>
            <tbody>
              { filterBOm.length > 0 ? (
                 filterBOm.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}  </td>
                         <td>  <button
                      className="btn btn-warning"

                      onClick={() => handleEdit(item)}
                    >
                      <CiEdit size={20} />
                    </button>
                    </td>
                    <td>{JSON.parse(item.product).name}</td>

                    <td>{item.qty} </td>
                    <td>{item.loss} </td>

               
                  </tr>
                ))) : (
                <tr>
                  <td colSpan="8" className="text-center text-danger fw-bold text-muted">No data found</td>
                </tr>
              )}
            </tbody>

          </table>
        </div>

      </div>

    </div>
  )
}

export default Bom_master